import { useState } from 'react';
import styled from 'styled-components';
import physicalSim from '../../../assets/images/physical_sim.png';
import virtualSim from '../../../assets/images/virtual_sim.png';
import { Button } from '../../../components/Button';
import { CloseIcon } from '../../../assets/icons/close';

export const useFindCodeLink = () => {
  const [showHelper, setShowHelper] = useState<boolean>(false);

  const LinkButton = (
    <Link onClick={() => setShowHelper(true)}>Where to find your activation code?</Link>
  );

  const HelperModalComponent = showHelper ? (
    <HelperModal onClose={() => setShowHelper(false)} />
  ) : null;

  return { LinkButton, HelperModalComponent };
};

type HelperModalProps = {
  onClose: () => void;
};

const HelperModal = ({ onClose }: HelperModalProps) => {
  const goToLink = (url: string) => {
    window.open(url, '_blank');
  };

  return (
    <HelperBackground>
      <ImagesWrapper>
        <CloseWrapper onClick={onClose}>
          <CloseIcon />
        </CloseWrapper>
        <CardsWrapper>
          <CardWrapper>
            <CardImage src={virtualSim} alt="sim card" />
            <CardTitle>Virtual SIM</CardTitle>
            <CardHelperText>
              Sticker located on the side of your camera - use the 4 digit code if present or the
              ICCID if not present
            </CardHelperText>
          </CardWrapper>
          <CardWrapper>
            <CardImage src={physicalSim} alt="sim card" />
            <CardTitle>Physical SIM</CardTitle>
            <CardHelperText>
              If your camera doesn't feature our digital SIM, you can upgrade using a physical SIM
              which we can send out to you.
            </CardHelperText>
          </CardWrapper>
        </CardsWrapper>
        <CardWrapper>
          <WarningText>Important! (Using a Physical SIM?)</WarningText>
          <CardHelperText>
            To offer you a better servive we've moved to a new provider and you will need to update the APN settings for the camera
            to be able to read our new SIM.
          </CardHelperText>
          <Button onClick={() => goToLink('https://www.farmstream.co.uk/pages/apn-settings')}>
            Steps to update APN
          </Button>
        </CardWrapper>
      </ImagesWrapper>
    </HelperBackground>
  );
};

const Link = styled.button`
  text-align: center;
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.primary};
  font-weight: 600;
`;

const CardTitle = styled.h3`
  margin: 0;
  font-size: ${({ theme }) => theme.fontSize.extraSmall};
  font-weight: 600;
`;

const WarningText = styled.h4`
  font-size: ${({ theme }) => theme.fontSize.medium};
  margin: 0;
`;

const CardHelperText = styled.p`
  font-size: ${({ theme }) => theme.fontSize.extraSmall};
  text-align: center;
`;

const CardWrapper = styled.div`
  padding: 1rem;
  border-radius: 0.5rem;
  background-color: ${({ theme }) => theme.colors.gray};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  width: 100%;
`;

const HelperBackground = styled.div`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  padding: 1rem;
`;

const CloseWrapper = styled.div`
  position: sticky;
  top: 0;
  background-color: ${({ theme }) => theme.colors.gray};
  padding: 0.5rem;
  border-radius: 0.5rem;
  width: 2.5rem;
  height: 2.5rem;
  align-self: flex-end;
  cursor: pointer;
`;

const CardImage = styled.img`
  height: 10rem;

  @media (max-width: 850px) {
    width: 100%;
    height: unset;
  }
`;

const CardsWrapper = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 850px) {
    flex-direction: column;
    width: 100%;
  }
`;

const ImagesWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-direction: column;
  padding: 2rem;
  background-color: white;
  border-radius: 0.5rem;
  max-width: 60rem;

  @media (max-width: 850px) {
    width: 100%;
    padding: 1rem;
    height: 100%;
    overflow-y: auto;
  }
`;
